// extracted by mini-css-extract-plugin
export default {"loading":"spinner_loading__FzYCG","spinnerLoading":"spinner_spinnerLoading__rQ7NK","spin":"spinner_spin__4bT3x"};